import {
  useNeopaymentSubscribeMutation,
  useNeopaymentGetBillingPortalQuery,
} from '@app/services/auto-generated/neopayment'
import { useNavigate } from 'react-router-dom'
import { LOGIN_ROUTE, SIMPLE_LOGIN_ROUTE } from '@common/constants/routes'
import { useUser } from '@features/auth/hooks'
import errorHandler from '@common/utils/error-handler'
import { useState } from 'react'
import { useAuthWhoamiQuery } from '@app/services/auto-generated/auth'

export const useSubscription = () => {
  const [subscribe] = useNeopaymentSubscribeMutation()
  const { data: billingPortal } = useNeopaymentGetBillingPortalQuery()
  const navigate = useNavigate()
  const { user } = useUser()
  const { data: freshUserData } = useAuthWhoamiQuery(undefined, {
    refetchOnMountOrArgChange: true,
    skip: !user,
  })
  const [loadingPlan, setLoadingPlan] = useState<string | null>(null)

  const handleManageSubscription = () => {
    if (billingPortal?.portal_url) {
      window.location.href = billingPortal.portal_url
    }
  }

  const handleSubscribe = async (
    plan: 'basic' | 'pro' | 'team',
    period: '1_month' | '6_month' = '1_month',
  ) => {
    const currentUser = freshUserData || user

    if (!currentUser) {
      navigate(SIMPLE_LOGIN_ROUTE, {
        state: { from: { pathname: window.location.pathname } },
      })
      return
    }

    try {
      setLoadingPlan(plan)
      const response = await subscribe({
        subscriptionRequest: { plan, period },
      }).unwrap()

      if (response?.checkout_url) {
        window.location.href = response.checkout_url
      }
    } catch (error) {
      console.error(errorHandler(error))
    } finally {
      setLoadingPlan(null)
    }
  }

  return {
    handleSubscribe,
    loadingPlan,
    handleManageSubscription,
    billingPortal,
    user: freshUserData || user,
  }
}
